// eslint-disable-next-line no-shadow
export enum PricingPagePlans {
	FREE = 'Free',
	BASIC = 'Basic',
	STANDARD = 'Standard',
	ELITE_PLUS = 'Elite++',
	ULTRA = 'Ultra',
	ADD_ON_PACK = 'Extra credits pack',
}
